import { render, staticRenderFns } from "./variant-consumables.vue?vue&type=template&id=1ff0e32a&scoped=true"
import script from "./variant-consumables.vue?vue&type=script&lang=js"
export * from "./variant-consumables.vue?vue&type=script&lang=js"
import style0 from "./variant-consumables.vue?vue&type=style&index=0&id=1ff0e32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff0e32a",
  null
  
)

export default component.exports